"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleLoading = exports.Loading = exports.ELLIPSES_TIMEOUT = void 0;
// to be moved to ui-components (Epic EN-2537)
const react_1 = __importStar(require("react"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const classnames_1 = __importDefault(require("classnames"));
const loading_styles_1 = require("./loading.styles");
exports.ELLIPSES_TIMEOUT = 250;
const Loading = ({ iconOrientation = 'bottom', isLoading, label = 'Loading', progressSize = 40, rootClass, showEllipsis = true, className, }) => {
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [ellipses, setEllipses] = (0, react_1.useState)('');
    let timer = null;
    let ellipsesTimer = null;
    const timeout = 0;
    const clearTimers = () => {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        if (ellipsesTimer) {
            clearInterval(ellipsesTimer);
            ellipsesTimer = null;
        }
    };
    const showLoading = () => setLoading(true);
    const updateEllipses = () => {
        setEllipses((prevEllipses) => (prevEllipses.length < 3 ? `.${prevEllipses}` : ''));
    };
    const setTimers = () => {
        timer = setTimeout(showLoading, timeout);
        ellipsesTimer = setInterval(updateEllipses, exports.ELLIPSES_TIMEOUT);
    };
    const updateTimers = (isLoading) => {
        const hasTimers = timer !== null && ellipsesTimer !== null;
        if (isLoading && !hasTimers) {
            setTimers();
        }
        else if (!isLoading) {
            clearTimers();
        }
    };
    (0, react_1.useEffect)(() => {
        updateTimers(isLoading);
        return () => clearTimers();
    }, [isLoading]);
    if (!isLoading || !loading) {
        return null;
    }
    return (react_1.default.createElement(loading_styles_1.StyledLoading, { className: (0, classnames_1.default)(iconOrientation, rootClass, className) }, label && (react_1.default.createElement(Typography_1.default, { variant: "caption" }, label, showEllipsis && ellipses)), react_1.default.createElement(CircularProgress_1.default, { size: progressSize })));
};
exports.Loading = Loading;
exports.default = exports.Loading;
const SimpleLoading = () => react_1.default.createElement(exports.Loading, { isLoading: true, label: "loading" });
exports.SimpleLoading = SimpleLoading;
